// extracted by mini-css-extract-plugin
export default {"container":"Map-module--container--dec2d","map":"Map-module--map--a7f95"};